















































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Upload from '@/components/Upload/index.vue'
import { uploadImage } from '@/utils/util'
import VisitorApi from '@/api/visitor'
import TaskApi from '@/api/task'
import { ossUploadFile } from '@/utils/oss'
// import VideoList from '../../AiiTasks/videoList.vue'
import VideoList from './videoList.vue'
import videojs from 'video.js'
@Component({
	name: 'Uploads',
	components: {
		Upload,
		VideoList,
	},
})
export default class Uploads extends Vue {
	@Prop({
		default: () => ({
			width: 880,
			height: 495,
			controls: true,
			autoplay: false,
			preload: 'auto',
		}),
	})
	@Prop()
	private imgName!: any
	@Prop()
	private children!: any
	@Prop()
	private data!: any
	@Prop()
	private type!: any
	@Prop()
	private isInHospital!: any

	private accept: string = ''
	private sizeLimit = 10
	private maxNum = 10
	private playing = false
	private audioUrl = ''
	private watching = false
	private currentVideo: any = ''
	private player: any = null
	private options!: Object
	private isAudioShow = false
	private videoUrl = ''
	private audioData: any = {}
	private mounted() {
		// Do not use both data-setup and an options object.
		this.player = videojs(this.$refs.myPlayer, this.options)
	}
	@Watch('children')
	private getChildren(val: any) {
		if (this.type === '7002' && this.isInHospital && val.length === 0) {
			this.children.push({
				type: `h0${this.children.length + 1}`,
				picName: `医院${this.children.length + 1}`,
				list: [],
			})
		}
	}
	@Watch('playing')
	private onPlayingChange() {
		let audio: any = this.$refs.audio
		if (!this.audioUrl) {
			return
		}
		if (!audio.canPlayType('audio/mp3')) {
			this.$message.error(
				'当前浏览器不支持播放，请下载直接播放或更换浏览器播放！'
			)
			return
		}
		audio.src = this.audioUrl
		if (this.playing) {
			audio.play()
			// this.pastTime =
			// 	audio.currentTime === audio.duration ? 0 : audio.currentTime
			// this.duration = audio.duration
			// this.setTimer()
		} else {
			audio.pause()
			// this.timer && clearInterval(this.timer)
		}
	}
	@Watch('currentVideo')
	private onVideoChange() {
		this.player.src({ type: 'video/mp4', src: this.currentVideo.fileUrl })
	}
	@Watch('isAudioShow')
	private onAudio() {
		let audioPlay: any = this.$refs.audioPlay
		if (this.isAudioShow) {
			setTimeout(() => {
				audioPlay.src = this.audioData.fileUrl
				this.$nextTick(() => {
					audioPlay.load()
				})
			}, 800)
		} else {
			audioPlay.pause()
		}
	}
	private async reupload(obj: any, isFlag: any) {
		if (
			this.type == '7001' ||
			this.type == '7002' ||
			this.type == '7003' ||
			this.type == '0900'
		) {
			this.accept = '.png,.jpg,.jpeg'
			this.sizeLimit = 10
			this.maxNum = 100
		} else if (this.type === 'report') {
			this.accept = '.pdf,.doc,.docx,.xls,.xlsx'
			this.sizeLimit = 200
			this.maxNum = 20
		} else if (this.type === 'audio') {
			this.accept = '.mp3,.wav,.m4a,.aac,.flac,.webm,.3gp,.amr,.opus'
			this.sizeLimit = 80
			this.maxNum = 30
		} else if (this.type === '0000') {
			this.accept = '.mp4,.m4v,.mov,.avi,.wmv,.flv,.mkv'
			this.sizeLimit = 500
			this.maxNum = 20
		} else {
			this.accept = '.png,.jpg,.jpeg'
			this.sizeLimit = 10
			this.maxNum = 100
		}
		this.$nextTick(async () => {
			const files = await (this.$refs.upload as any).get()
			const currentImageNum = (this.children && this.children.length) || 0
			if (this.maxNum && currentImageNum + files.length > this.maxNum) {
				this.$message.error(`最多上传${this.maxNum}张`)
			} else {
				this.uploadImages(files, obj, isFlag)
			}
		})
	}
	public async uploadImages(files: any, objData: any, isFlag: any) {
		const hide: any = this.$message.loading('上传中...', 0)
		for (let file of files) {
			const FileExt = file.name.replace(/.+\./, '')
			if (this.accept.indexOf(FileExt.toLowerCase()) < 0) {
				this.$message.error(
					`${file.name}无法上传，当前类型不支持${FileExt}类型上传`
				)
				continue
			}
			const isPic =
				['png', 'jpeg', 'jpg', 'bmp'].indexOf(FileExt.toLowerCase()) !== -1
			const isVideo =
				['mp4', 'm4v', 'mov', 'avi', 'wmv', 'flv', 'mkv'].indexOf(
					FileExt.toLowerCase()
				) !== -1
			if (isPic) {
				const info: any = await this.orderBaseInfo()
				const data = info.data
				const visitorCardNo = data.visitorCardNo
				let visitorInfo = ''
				if (visitorCardNo) {
					visitorInfo = data.visitorName + `（${visitorCardNo}）`
				} else {
					visitorInfo = data.visitorName ? data.visitorName : ''
				}
				let objs = {
					// picName: file.name,
					picName: isFlag ? objData.picName : this.imgName,
					file: file,
					caseNo: data.caseNo,
					visitorInfo,
					time: info.responseTime,
				}
				const formData = await uploadImage(objs)
				VisitorApi.operateAndUpload({
					formData,
					params: {
						cmd: 'imageMogr2/thumbnail/1500x1500',
					},
				}).then((res: any) => {
					const obj = {
						data: res.data,
						type: isFlag ? objData.type : this.type,
						// picName: file.name,
						picName: isFlag ? objData.picName : this.imgName,
					}
					this.$emit('upload', obj)
				})
			} else if (isVideo) {
				const oss: any = await ossUploadFile(file)
				const ossObj = {
					orginFileName: oss.fileName,
					yunFileName: oss.fileUrl,
					type: this.type,
					url: oss.url,
				}
				this.$emit('upload', ossObj)
			} else {
				await this.uploadFile(file)
			}
		}
		setTimeout(hide, 500)
	}
	public async orderBaseInfo() {
		const res = await VisitorApi.orderBaseInfo(this.$route.params.orderId)
		return res
	}
	public uploadFile(file: any) {
		const formData = new FormData()
		formData.append('filecontent', file)
		VisitorApi.uploadFile({ formData })
			.then((res: any) => {
				const obj = {
					data: res.data,
					type: this.type,
					picName: file.name,
				}
				this.$emit('upload', obj)
			})
			.catch((err: any) => {
				console.log(err)
			})
	}
	public handleRemove(item: any, index: any) {
		this.$confirm({
			title: '提示',
			content: '确认删除吗 ?',
			onOk: async () => {
				this.children.splice(index, 1)
				const obj = {
					data: item,
					type: this.type,
					index: index,
				}
				this.$emit('remove', obj)
			},
		})
	}
	public remove(data: any) {
		this.$confirm({
			title: '提示',
			content: '确认删除吗 ?',
			onOk: async () => {
				this.children.splice(data.index, 1)
				this.$emit('remove', data)
			},
		})
	}
	public removeHospital(item: any, index: any, items: any, indexs: any) {
		this.$confirm({
			title: '提示',
			content: '确认删除吗 ?',
			onOk: async () => {
				this.children[index].list.splice(indexs, 1)
				const obj = {
					data: items,
					type: item.type,
					index: indexs,
				}
				this.$emit('remove', obj)
			},
		})
	}
	public openImg(Img: any) {
		this.$emit('openImg', Img)
	}
	public openReport(data: any) {
		const FileExt = data.picName.replace(/.+\./, '')
		const isPDF = ['pdf'].indexOf(FileExt.toLowerCase()) !== -1
		if (isPDF) {
			if (data.fileUrl) {
				window.open(data.fileUrl + '?disposition=inline')
			} else {
				TaskApi.getFileUrl(data.fileId).then((res: any) => {
					window.open(res.data + '?disposition=inline')
				})
			}
		} else {
			if (data.fileUrl) {
				window.open(
					`http://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(
						data.fileUrl.trim()
					)}`
				)
			} else {
				TaskApi.getFileUrl(data.fileId).then((res: any) => {
					window.open(
						`http://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(
							res.data.trim()
						)}`
					)
				})
			}
		}
	}
	public playAudio(data: any, index: number) {
		let audio: any = this.$refs.audio
		if (data.fileUrl) {
			audio.src = data.fileUrl
		} else {
			TaskApi.getFileUrl(data.fileId).then((res: any) => {
				audio.src = res.data
			})
		}
		if (audio.paused) {
			this.playing = true
			audio.play()
		} else {
			this.playing = false
			audio.pause()
		}
	}
	private pause(data: any) {
		// this.audioUrl = data.fileUrl
		// this.playing = false
		// this.children.forEach((item: any) => {
		// 	if (data.fileId == item.fileId) {
		// 		this.$set(item, 'playing', false)
		// 	}
		// })
	}

	private play(data: any) {
		this.isAudioShow = true
		if (data.fileUrl) {
			if (this.audioData.fileUrl !== data.fileUrl) {
				this.audioData = data
			}
		} else {
			TaskApi.getFileUrl(data.fileId).then((res: any) => {
				this.audioData.fileUrl = res.data
			})
		}
	}
	private audioClose() {
		this.isAudioShow = false
	}
	private openVideo(data: any) {
		this.watching = true
		if (this.currentVideo.fileUrl !== data.fileUrl) {
			this.currentVideo = data
		}
	}
	private closeModal() {
		this.watching = false
		this.player.pause()
	}
	private addHospital() {
		if (this.children.length >= 5) {
			return
		}
		this.children.push({
			type: `h0${this.children.length + 1}`,
			picName: `医院${this.children.length + 1}`,
			list: [],
		})
	}
	private beforeDestroy() {
		if (this.player) {
			this.player.dispose()
		}
	}
}
